import {
    Button,
    CircularProgress, Container, FormControl,
    FormHelperText,
    Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Page from 'src/components/Page';
import BoxWrapper from 'src/styles/BoxWrapper';
import { apiService } from '../../api/axiosClient';
import PageHeader from '../../components/page-header';
import FileUploaderSingle from '../../components/upload/FileUploaderSingle';
import { useGetProductsQuery } from '../../store/productApi';
import DropzoneWrapper from '../../styles/react-dropzone';

const NewProduct = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [category1, setCategory1] = useState([])
  const [category2, setCategory2] = useState([])
  const [category3, setCategory3] = useState([])
  const [files, setFiles] = useState([])
  const { refetch } = useGetProductsQuery();
  const defaultValues = {
    category1: '',
    category2: '',
    category3: '',
    cat_id: '',
    pd_packing: '',
    name: '',
    spec_desc: '',
    pd_cas: '',
    it_use: '1',
    brand: 'ALADDIN',
    price: '0',
    pd_type: 'AL',
    pd_lead: '7',    
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({ defaultValues })

  const loadCategory1 = () => {
    const fetchData = async () => {
        const _response = await apiService.get('/category/level/1')
        const _payload = _response.data;

        setCategory1(_payload.list)
    }

    fetchData().catch(e => console.error(e));
  }

  const loadCategory2 = (level) => {
    const fetchData = async () => {
        const _response = await apiService.get(`/category/level/2?q=${level}`)
        const _payload = _response.data;
        setCategory2(_payload.list)
    }

    fetchData().catch(e => console.error(e));
  }

  const loadCategory3 = (level) => {
    const fetchData = async () => {
        const _response = await apiService.get(`/category/level/3?q=${level}`)
        const _payload = _response.data;
        setCategory3(_payload.list)
    }

    fetchData().catch(e => console.error(e));
  }

  useEffect(loadCategory1, [])

  const getCategoryId = (level1, level2, level3, callback) => {
    const fetchData = async () => {
      const _response = 
        await apiService.get(`/category/level?level1=${level1}&level2=${level2}&level3=${level3}`)
      const _payload = _response.data;

      callback(_payload.data.id, _payload.data.levelname)
    }

    fetchData().catch(e => console.error(e));
  }

  const onSubmit = async (data, e) => {
    setLoading(true)

    const [file] = files;

    getCategoryId(data.category1, data.category2, data.category3, async (categoryid, categoryname) => {

        const formData = new FormData()
        
        formData.append('category1', data.category1);
        formData.append('category2', data.category2);
        formData.append('category3', data.category3);
        formData.append('cat_id', data.cat_id);
        formData.append('pd_packing', data.pd_packing);
        formData.append('name', data.name);
        formData.append('spec_desc', data.spec_desc);
        formData.append('pd_cas', data.pd_cas);
        formData.append('it_use', data.it_use);
        formData.append('brand', data.brand);
        formData.append('price', data.price);
        formData.append('pd_type', data.pd_type);
        formData.append('pd_lead', data.pd_lead);
        formData.append('aladdin_sku', data.aladdin_sku);
        formData.append('file', file);

        try {
            const response = await apiService.postFormData('/products', formData);
            toast.success('등록 되었습니다.');
            refetch();
        } catch (error) {
            console.error('Error creating product:', error);
        } finally {
            setLoading(false);
        }
    }) 
  }

  return (
    <Page title="Product">
        <Container>
            <PageHeader
                title={
                    <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                        <Typography variant='h5' color='#666CFF'>
                            상품 등록
                        </Typography>
                    </Stack>
                }
                subtitle={
                    <Typography variant='body2'>
                        상품 카테고리를 선택한후 상품 정보를 입력해주세요. SKU는 상품등록시 자동으로 생성됩니다.
                    </Typography>
                }
            />
            <BoxWrapper>
            <form onSubmit={handleSubmit(onSubmit)} id="productform">
                <Grid container spacing={6}>
                    
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel id='type1'>1차 카테고리</InputLabel>
                            <Controller
                                name='category1'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <Select
                                    label='1차 카테고리'
                                    value={value}
                                    onChange={(e) => {
                                    onChange(e)
                                    setCategory3([])
                                    loadCategory2(e.target.value)                          
                                    }}
                                    labelId='type1'
                                    variant="standard"
                                >
                                    {category1 !== undefined &&
                                        category1.map(item => (
                                            <MenuItem key={item} value={item}>
                                                {item}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                                )}
                            />
                            {errors.category1 && (
                                <FormHelperText>필수 항목입니다.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel id='type2'>2차 카테고리</InputLabel>
                            <Controller
                                name='category2'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <Select
                                    label='2차 카테고리'
                                    value={value}
                                    disabled={category2.length === 0 ? true : false}                 
                                    onChange={(e) => {
                                    onChange(e)
                                    loadCategory3(e.target.value)
                                    }}
                                    labelId='type2'
                                    variant="standard"
                                >
                                    {category2 !== undefined &&
                                    category2.map(item => (
                                        <MenuItem key={item} value={item}>
                                        {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                                )}
                            />
                            {errors.category2 && (
                                <FormHelperText>필수 항목입니다.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                        <InputLabel id='type3'>3차 카테고리</InputLabel>
                            <Controller
                                name='category3'
                                control={control}
                                rules={{ required: false }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <Select
                                    label='3차 카테고리'
                                    value={value}
                                    disabled={category3.length === 0 ? true : false}
                                    onChange={onChange}
                                    labelId='type3'
                                    variant="standard"
                                >
                                    {category3 !== undefined &&
                                    category3.map(item => (
                                        <MenuItem key={item} value={item}>
                                        {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                                )}
                            />
                        </FormControl>
                    </Grid>


                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                            <Controller
                                name='cat_id'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='CAT No'
                                    id='cat_id'
                                    onChange={onChange}
                                    placeholder='CAT No를 입력해주세요'
                                    error={Boolean(errors.cat_id)}
                                    helpertext={errors?.message}
                                    aria-describedby='validation-async-cat_id'
                                    variant="standard"
                                />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                        <Controller
                            name='pd_packing'
                            control={control}
                            rules={{ required: true }}
                            defaultValue=""
                            render={({ field: { value, onChange } }) => (
                            <TextField
                                value={value}
                                label='용량'
                                id='pd_packing'
                                onChange={onChange}
                                placeholder='용량를 입력해주세요'
                                error={Boolean(errors.pd_packing)}
                                helpertext={errors?.message}
                                aria-describedby='validation-async-pd_packing'
                                variant="standard"
                            />
                            )}
                        />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                            <Controller
                                name='name'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='상품명'
                                    id='name'
                                    onChange={onChange}
                                    placeholder='상품명을 입력해주세요'
                                    error={Boolean(errors.name)}
                                    helpertext={errors?.message}
                                    aria-describedby='validation-async-name'
                                    variant="standard"
                                />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                            <Controller
                                name='aladdin_sku'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='Aladdin SKU'
                                    id='aladdin_sku'
                                    onChange={onChange}
                                    placeholder='Aladdin SKU를 입력해주세요'
                                    error={Boolean(errors.aladdin_sku)}
                                    helpertext={errors?.message}
                                    aria-describedby='validation-async-aladdin_sku'
                                    variant="standard"
                                />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                            <Controller
                                name='spec_desc'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='Spec'
                                    id='spec_desc'
                                    onChange={onChange}
                                    placeholder='Spec을 입력해주세요'
                                    error={Boolean(errors.spec_desc)}
                                    helpertext={errors?.message}
                                    aria-describedby='validation-async-spec_desc'
                                    variant="standard"
                                />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                            <Controller
                                name='pd_cas'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='CAS No'
                                    id='pd_cas'
                                    onChange={onChange}
                                    placeholder='CAS No을 입력해주세요'
                                    error={Boolean(errors.pd_cas)}
                                    helpertext={errors?.message}
                                    aria-describedby='validation-async-pd_cas'
                                    variant="standard"
                                />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                            <Controller
                                name='it_use'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='노출'
                                    id='it_use'
                                    onChange={onChange}
                                    placeholder='0 혹은 1을 입력해주세요'
                                    error={Boolean(errors.it_use)}
                                    helpertext={errors?.message}
                                    aria-describedby='validation-async-it_use'
                                    variant="standard"
                                />
                                )}
                            />
                        </FormControl>
                    </Grid>


                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                            <Controller
                                name='brand'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='브랜드'
                                    id='brand'
                                    onChange={onChange}
                                    placeholder='브랜드를 입력해주세요'
                                    error={Boolean(errors.brand)}
                                    helpertext={errors?.message}
                                    aria-describedby='validation-async-brand'
                                    variant="standard"
                                />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                            <Controller
                                name='price'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='단가'
                                    id='price'
                                    onChange={onChange}
                                    placeholder='단가를 입력해주세요'
                                    error={Boolean(errors.price)}
                                    helpertext={errors?.message}
                                    aria-describedby='validation-async-price'
                                    variant="standard"
                                />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                            <Controller
                                name='pd_type'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='수입국'
                                        id='pd_type'
                                        onChange={onChange}
                                        placeholder='수입국을 입력해주세요'
                                        error={Boolean(errors.pd_type)}
                                        helpertext={errors?.message}
                                        aria-describedby='validation-async-pd_type'
                                        variant="standard"
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <FormControl fullWidth>
                            <Controller
                                name='pd_lead'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='납기일'
                                        id='pd_lead'
                                        onChange={onChange}
                                        placeholder='납기일를 입력해주세요'
                                        error={Boolean(errors.pd_lead)}
                                        helpertext={errors?.message}
                                        aria-describedby='validation-async-pd_lead'
                                        variant="standard"
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>                    

                    <Grid item xs={12}>
                        <DropzoneWrapper>
                        <FileUploaderSingle files={files} setFiles={setFiles} />
                        </DropzoneWrapper>
                    </Grid>

                </Grid>
            </form>
            </BoxWrapper>

            <Stack direction="row" spacing={2} sx={{ py: 16, justifyContent: 'center' }}>
                <Button type="submit" form="productform" variant='contained'>
                    {loading ? (
                    <CircularProgress
                        sx={{
                        color: 'common.white',
                        width: '20px !important',
                        height: '20px !important',
                        mr: theme => theme.spacing(2)
                        }}
                    />
                    ) : null}
                    등록
                </Button>
                <Button variant='outlined' color='secondary' onClick={() => {navigate(-1)}}>
                    취소
                </Button>
            </Stack>
        </Container>
    </Page>
  )
}

export default NewProduct
